import React from "react";
import { formatPrice, parsePrice } from "../utils/format";

const SupplierRow = ({ row, priceBasis, quantity, onQuantityChange, onAdd }) => (
    <div className="pc-supplier-row">
        <div className="pc-supplier-info">
            <div className="pc-supplier-source">{row.source}</div>
            <div className="pc-supplier-manufacturer">{row.manufacturer}</div>
        </div>
        <div className="pc-supplier-prices">
            <span className={`pc-price-chip ${priceBasis === "cash" ? "primary" : ""}`}>
                {formatPrice(parsePrice(row.price_cash))} нал
            </span>
            <span className={`pc-price-chip ${priceBasis === "noncash" ? "primary" : ""}`}>
                {formatPrice(parsePrice(row.price_non_cash))} безнал
            </span>
        </div>
        <div className="pc-supplier-date">{row.price_update_date}</div>
        <input
            className="pc-qty-input"
            type="number"
            min={1}
            value={quantity}
            onChange={(e) => onQuantityChange(e.target.value)}
        />
        <button className="pc-add-btn" onClick={onAdd}>Добавить</button>
    </div>
);

export default SupplierRow;
